
export default {
  data: () => ({


      rawData:      [],
      schList:      [],

      canvasForms:  null,

      columns: [
        {name: 'Area', code: 'AREA',  width: 70, head: ''},
        {name: 'Zone', code: 'ZONE',  width: 100, head: ''},
        
        {name: 'Total',  code: 'SC_TOT', width: 38, head: ''},
        {name: 'Plan',   code: 'SC_PF',  width: 38, head: ''},
        {name: 'Act.',   code: 'SC_CP',  width: 38, head: 'Cutting'},
        {name: 'Ahead',  code: 'SC_AD',  width: 38, head: ''},
        {name: 'Behind', code: 'SC_BH',  width: 38, head: ''},
        {name: 'Total',  code: 'FB_TOT', width: 38, head: ''},
        {name: 'Plan',   code: 'FB_PF',  width: 38, head: ''},
        {name: 'Act.',   code: 'FB_CP',  width: 38, head: 'Fab.'},
        {name: 'Ahead',  code: 'FB_AD',  width: 38, head: ''},
        {name: 'Behind', code: 'FB_BH',  width: 38, head: ''},
        {name: 'Total',  code: 'AS_TOT', width: 38, head: ''},
        {name: 'Plan',   code: 'AS_PF',  width: 38, head: ''},
        {name: 'Act.',   code: 'AS_CP',  width: 38, head: 'Assembly'},
        {name: 'Ahead',  code: 'AS_AD',  width: 38, head: ''},
        {name: 'Behind', code: 'AS_BH',  width: 38, head: ''},
        {name: 'Total',  code: 'PT_TOT', width: 38, head: ''},
        {name: 'Plan',   code: 'PT_PF',  width: 38, head: ''},
        {name: 'Act.',   code: 'PT_CP',  width: 38, head: 'Painting'},
        {name: 'Ahead',  code: 'PT_AD',  width: 38, head: ''},
        {name: 'Behind', code: 'PT_BH',  width: 38, head: ''},
        {name: 'Total',  code: 'PE2_TOT',width: 38, head: ''},
        {name: 'Plan',   code: 'PE2_PF', width: 38, head: ''},
        {name: 'Act.',   code: 'PE2_CP', width: 38, head: '2nd PE'},
        {name: 'Ahead',  code: 'PE2_AD', width: 38, head: ''},
        {name: 'Behind', code: 'PE2_BH', width: 38, head: ''},
        {name: 'Total',  code: 'ER_TOT', width: 38, head: ''},
        {name: 'Plan',   code: 'ER_PF',  width: 38, head: ''},
        {name: 'Act.',   code: 'ER_CP',  width: 38, head: 'Setting'},
        {name: 'Ahead',  code: 'ER_AD',  width: 38, head: ''},
        {name: 'Behind', code: 'ER_BH',  width: 38, head: ''},
        
      ],
      tblLen: 0,
      





  }),

  computed: {
    ready2draw() {
      return (
        this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
  },

}